<template>
  <div class="">
    <div class="row align-items-start">
      <div class="col">
        <CusipDetail 
        v-on:idcprice="setIdcPrice" 
        v-bind:cusipId="bidwanted.cusipId" 
        v-bind:cusipName="bidwanted.cusip" 
        v-bind:cusipIdcPrice="bidwanted.idcPrice"
        v-bind:offerinecn="setOfferInEcn"
        />
      </div>
    </div>
    <div class="row align-items-start">
      <div class="col-md-4">
        <MsrbDetail v-bind:cusipId="bidwanted.cusip"/>
      </div>
      <div class="col-md-4">
        <OurBidsDetail v-bind:cusipId="bidwanted.cusip"/>
      </div>
      <div class="col-md-4">
        <OurTradeDetail v-bind:cusipId="bidwanted.cusip"/>
      </div>
    </div>
  </div>
              <!-- <div class="modal-body">
                <div>
                    <b-tabs content-class="mt-3">
                        <b-tab title="Cusip" active>
                            <CusipDetail v-bind:cusipId="bidwanted.cusipId" v-bind:cusipName="bidwanted.cusip"/>
                        </b-tab>
                        <b-tab title="MSRB Trades">
                          <MsrbDetail v-bind:cusipId="bidwanted.cusip"/>
                        </b-tab>
                        <b-tab title="Our Bids">
                            <OurBidsDetail v-bind:cusipId="bidwanted.cusip"/>
                        </b-tab>
                        <b-tab title="Our Trades">
                          <OurTradeDetail v-bind:cusipId="bidwanted.cusip"/>
                        </b-tab>
                    </b-tabs>
                </div>
              </div> -->
  </template>
  <script>
  import CusipDetail from "./CusipDetails.vue";
  import OurBidsDetail from "./OurBidDetails.vue";
  import OurTradeDetail from "./OurTradeDetails.vue";
  import MsrbDetail from "./MsrbDetail.vue";
  export default {
        name: 'supportdata',
        components :{
            CusipDetail,
            OurBidsDetail,
            OurTradeDetail,
            MsrbDetail
        },
        props :["bidwanted"],
        watch: { 
          bidwanted: function(newVal, oldVal) { // watch it
                console.log('Prop changed: ', newVal, ' | was: ', oldVal)
              }
        },
        data() {
            return {
                

            };
        },
        methods: {
          setIdcPrice(idcPrice){
            this.$emit("idcprice",idcPrice);
          },
          setOfferInEcn(offer){
            this.$emit("offerinecn",offer);
          }
        },
        mounted() {
            
        }
  };
  </script>
  <style>
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    margin: 0 auto;
    max-width: 960px;
  }

  .column {
    flex: 0 0 31%;
    margin-bottom: 20px;
  }

  .column:first-child {
    margin-right: 2%;
  }

  .column:last-child {
    margin-left: 2%;
  }

  .column img {
    width: 100%;
    height: auto;
  }

  .column h2 {
    font-size: 24px;
    margin: 10px 0;
  }

  .column p {
    font-size: 16px;
    line-height: 1.5;
    margin: 10px 0;
  }
</style>